import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthNavigator } from './routes/AuthNavigator';
import AppRoutes from './routes/Routes';
import MobileDetect from './utils/MobileDetect'; 

function App() {
    return (
        <Router>
            {/* <MobileDetect>   */}
                <AuthNavigator>
                    <AppRoutes />
                </AuthNavigator>
            {/* </MobileDetect> */}
        </Router>
    );
}

export default App;